import styled from 'styled-components';
import ButtonBase from '../base/Base';

const ButtonStandardSecondary = styled(ButtonBase)`
  background-color: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.black};
  padding: 1.5rem 2.5rem;
  width: ${props => props.width};
`;

export default ButtonStandardSecondary;



// WEBPACK FOOTER //
// ./src/components/atoms/buttons/standard/Secondary.js